import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { User } from '../_models/user.model';
import { CacheConstants } from '../_config/cache-constants';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  //private authSuscription!: Subscription;
  public userInfo = new BehaviorSubject<User>(this.getUser());

  username: string = '';
  component: string;

  constructor() {
    // this.authSuscription = this.authService.configObservable.subscribe(user => {
    //   this.saveUser(user);
    // });
  }

  set(key: string, item: object) {
    localStorage.setItem(key, JSON.stringify(item));
  }
  get(key: string) {
    const cacheItem = localStorage.getItem(key);
    if (cacheItem !== null) {
      const record = JSON.parse(cacheItem);
      return record;
    }
    return null;
  }
  remove(key: string) {
    localStorage.removeItem(key);
  }

  setUsername(username: string) {
    this.username = username;
    window.localStorage.setItem(CacheConstants.USERNAME_KEY, username);
  }

  getUsername() {
    return window.localStorage.getItem(CacheConstants.USERNAME_KEY);
  }

  clean(): void {
    // en vez de borrar toda la cache, mantenemos los idiomas
    //window.localStorage.clear();
    this.clearToken();
    this.clearUser();
    this.clearTokenData();
    localStorage.removeItem(CacheConstants.VALIDATIONDATA_KEY);
    //localStorage.removeItem(CacheConstants.LANGUAGE_CACHE_VERSION);
    this.clearPageCache();
    if(localStorage.length>10){
      localStorage.clear();
    }
    this.userInfo.next(null);
  }

  public saveUser(user: User): void {
    if (user != null) {
      let username = user.email;
      if(!username){
        username = user.userName;
      }
      this.setUsername(username);
      window.localStorage.removeItem(CacheConstants.USER_KEY);
      window.localStorage.setItem(
        CacheConstants.USER_KEY,
        JSON.stringify(user)
      ); //
    }
    this.userInfo.next(user);
  }
  public clearUser() {
    localStorage.removeItem(CacheConstants.USER_KEY);
    localStorage.removeItem(CacheConstants.USERNAME_KEY);
    localStorage.removeItem(CacheConstants.USER_ID_KEY);
    localStorage.removeItem(CacheConstants.COMMERCE_KEY);
    localStorage.removeItem(CacheConstants.USERDATA_KEY);
  }
  public updateVerifiedEmail() {
    // actualizar la visualización de email verificado en la web
    let user = this.getUser();
    if (user) {
      user.email_verified = true;
      this.saveUser(user);
    }
  }
  public getUser(): any {
    const user = localStorage.getItem(CacheConstants.USER_KEY);
    if (user) {
      return JSON.parse(user);
    }

    return null;
  }

  public isLoggedIn(): boolean {
    const user = localStorage.getItem(CacheConstants.USER_KEY);
    // console.log(user);
    if (user) {
      return true;
    }
    return false;
  }

  setComponent(component: string) {
    this.component = component;
  }

  getComponent() {
    return this.component;
  }

  public saveUserName(username: any): void {
    // console.log('save:' + username);
    localStorage.removeItem(CacheConstants.USERNAME_KEY);
    localStorage.setItem(CacheConstants.USERNAME_KEY, username); //
  }

  public saveToken(token: any): void {
    localStorage.removeItem(CacheConstants.TOKEN_KEY);
    localStorage.setItem(CacheConstants.TOKEN_KEY, token); //
  }

  public getToken(): string {
    const token = localStorage.getItem(CacheConstants.TOKEN_KEY);
    if (token) {
      return token;
    }
    return '';
  }

  public clearToken(): void {
    localStorage.removeItem(CacheConstants.TOKEN_KEY);
  }

  public setTokenData(tokenData: any): void {
    localStorage.setItem(CacheConstants.TOKEN_DATA, JSON.stringify(tokenData));
  }

  public getTokenData(): any {
    const tokenData = localStorage.getItem(CacheConstants.TOKEN_DATA);
    return tokenData ? JSON.parse(tokenData) : null;
  }

  public clearTokenData(): void {
    localStorage.removeItem(CacheConstants.TOKEN_DATA);
  }

  public clearPageCache() {
    let cacheVersion = localStorage.getItem(CacheConstants.PAGES_CACHE_VERSION);
    if (cacheVersion != null) {
      localStorage.removeItem(
        CacheConstants.PAGES_CACHE_VERSION +
          '_' +
          cacheVersion.replaceAll('"', '')
      );
    }
    localStorage.removeItem(CacheConstants.PAGES_CACHE_VERSION);
  }
  public clearLanguageCache() {
    let cacheVersion = localStorage.getItem(
      CacheConstants.LANGUAGE_CACHE_VERSION
    );
    if (cacheVersion != null) {
      localStorage.removeItem(
        CacheConstants.LANGUAGE_CACHE_VERSION +
          '_' +
          cacheVersion.replaceAll('"', '')
      );
    }
    localStorage.removeItem(CacheConstants.LANGUAGE_CACHE_VERSION);
  }

  public getValidationValue(): any {
    let validationdata = window.localStorage.getItem(
      CacheConstants.VALIDATIONDATA_KEY
    );
    if (validationdata) {
    } else {
      validationdata = this.getGuid();
      window.localStorage.setItem(
        CacheConstants.VALIDATIONDATA_KEY,
        validationdata
      ); //
    }
    return validationdata;
  }
  public getGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  getByPrefix(prefix: string) {
    const results: { key: string; value: any }[] = [];

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);

      if (key?.startsWith(prefix)) {
        const value = localStorage.getItem(key);

        if (value !== null) {
          results.push({
            key,
            value: JSON.parse(value),
          });
        }
      }
    }

    return results;
  }
}
